export const aboutData = {
  brandIntro: {
    title: '关于吃瓜网在线',
    subtitle: '吃瓜网在线是国内领先的娱乐八卦资讯聚合平台',
    paragraphs: [
      '吃瓜网在线成立于2025年，致力于为广大用户提供最新、最全面的娱乐八卦资讯服务。我们聚合51吃瓜网在线观看、黑料吃瓜网在线观看等热门入口，实时追踪网红塌房事件与黑料爆料视频，一站满足用户在线吃瓜需求。',
      '平台覆盖娱乐圈、网红圈、直播圈、电竞圈等多个领域，每日更新数百条独家爆料内容。我们的编辑团队由资深娱乐记者和网络侦探组成，确保每一条爆料都经过初步核实。',
      '截至目前，吃瓜网在线已积累超过500万注册用户，日均活跃用户超过80万，成为国内最具影响力的娱乐资讯平台之一。',
    ],
  },
  reputation: {
    title: '平台声誉与数据',
    stats: [
      { value: '500万+', label: '注册用户' },
      { value: '80万+', label: '日活用户' },
      { value: '5000+', label: '爆料文章' },
      { value: '3000+', label: '吃瓜视频' },
    ],
    highlights: [
      '多次登上微博热搜话题榜',
      '独家爆料多次被主流媒体报道转载',
      '平台内容被多个头部自媒体引用',
      '与多家MCN机构建立合作关系',
    ],
  },
  contact: {
    title: '联系我们',
    description: '无论是商务合作、爆料投稿还是意见建议，我们都欢迎你的来信。',
    email: 'hello@shangremen.cn',
    wechat: 'ChiguaOfficial',
    weibo: '@吃瓜网在线',
    address: '北京市朝阳区建国路88号SOHO现代城A座1208室',
    cooperation: [
      '品牌商务合作',
      '独家爆料投稿',
      '广告投放入驻',
      '媒体转载授权',
    ],
  },
  disclaimer: {
    title: '免责声明',
    content: [
      '吃瓜网在线（以下简称"本平台"）上发布的所有内容均来源于公开网络信息和用户投稿，仅供娱乐参考，不构成对任何个人或组织的指控或定论。',
      '本平台不对发布内容的真实性、准确性、完整性作出任何明示或暗示的保证。用户应自行判断信息可信度，理性吃瓜。',
      '如果内容涉及侵犯第三方合法权益（包括但不限于名誉权、肖像权、隐私权等），请联系本平台进行处理，我们将在核实后及时删除相关内容。',
      '本平台坚决反对任何诽谤、造谣和虚假信息传播行为。对于恶意编造和传播不实信息的用户，我们将保留追究法律责任的权利。',
    ],
  },
  privacy: {
    title: '隐私政策',
    content: [
      '吃瓜网在线高度重视用户的隐私保护。我们收集的信息仅用于改善用户体验和平台运营，不会向任何第三方出售或泄露用户的个人信息。',
      '我们使用Cookie和类似技术来分析用户行为，优化网站内容推荐。用户可以在浏览器设置中随时清除Cookie。',
      '用户订阅邮件资讯时提供的邮箱地址仅用于发送吃瓜快讯，用户可以随时退订。',
      '如对我们的隐私政策有任何疑问，欢迎通过"联系我们"中的方式与我们取得联系。',
    ],
  },
  team: [
    {
      name: '主编老王',
      role: '内容总监',
      avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20abstract%20avatar%20portrait%20with%20warm%20tones%20on%20a%20solid%20cream%20background%2C%20geometric%20shape%20inspired%20face%2C%20soft%20shadows%2C%20clean%20modern%20editorial%20style&width=100&height=100&seq=team-01&orientation=squarish',
    },
    {
      name: '爆料小能手',
      role: '资深编辑',
      avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20abstract%20avatar%20portrait%20with%20warm%20tones%20on%20a%20solid%20cream%20background%2C%20geometric%20shape%20inspired%20face%2C%20soft%20shadows%2C%20clean%20modern%20editorial%20style&width=100&height=100&seq=team-02&orientation=squarish',
    },
    {
      name: '数据分析师',
      role: '数据负责人',
      avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20abstract%20avatar%20portrait%20with%20warm%20tones%20on%20a%20solid%20cream%20background%2C%20geometric%20shape%20inspired%20face%2C%20soft%20shadows%2C%20clean%20modern%20editorial%20style&width=100&height=100&seq=team-03&orientation=squarish',
    },
  ],
};